<template>
  <section class="work-countries  container">
    <div class="work-countries__content  container-inner">
      <h2 class="work-countries__title">{{ $tHome('Select country for work') }}</h2>
      <div class="work-countries__list">
        <div v-for="country in countries"
             :key="country.id"
             :class="country.active ? null : '_disabled'"
             class="work-countries__item">
          <router-link-modified v-if="country.link"
                                :to="country.link"
                                class="work-countries__item-inner">
            <div :style="{backgroundImage: `url(${country.flag})`}"
                 class="work-countries__item-flag"></div>
            <div class="work-countries__item-name">{{ country.title }}</div>
            <div v-if="country.subtitle"
                 class="work-countries__item-note">{{ country.subtitle }}
            </div>
          </router-link-modified>
          <div v-else
               class="work-countries__item-inner">
            <div :style="{backgroundImage: `url(${country.flag})`}"
                 class="work-countries__item-flag"></div>
            <div class="work-countries__item-name">{{ country.title }}</div>
            <div v-if="country.subtitle"
                 class="work-countries__item-note">{{ country.subtitle }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'HomePageWorkCountries',
    props: {
      countries: Array
    },
    data() {
      return {}
    }
  }
</script>

<style lang="less">

</style>